import { FiltersModal } from './chunk-H4LHYZHJ.js';
import { WithFormProvider, RefinerFormDefaultId } from './chunk-TSRXERZ6.js';
import './chunk-JPIJK62K.js';
import './chunk-J3DBQDBT.js';
import './chunk-DNUFCL26.js';
import { WithMFEContext, useTemplates, useConditionalFilters, useUpdateLocations, ModalProvider } from './chunk-SBDRB6T7.js';
import { mapSearchModelToFormModel, mapFormModelToSearchModel } from '@aviv-search/transformers';
import { Box } from '@gemini/core';
import { Skeleton } from '@gemini/ui';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { jsx } from 'react/jsx-runtime';

var SearchEditSkeletontestId = "searchmfe-search-edit-skeleton-testid";
var SearchEditTemplate = ({
  trigger,
  title,
  submitText,
  cancelText,
  customElement,
  onCancel,
  formId = RefinerFormDefaultId
}) => {
  const { getValues, reset } = useFormContext();
  const [savedModel, setSavedModel] = useState(getValues());
  useConditionalFilters();
  const isUpdated = useUpdateLocations();
  const filterModalProps = {
    onOpen: () => setSavedModel(getValues()),
    onCancel: () => reset(savedModel),
    onReset: () => {
      reset(savedModel);
      onCancel?.();
    },
    onValidate: () => setSavedModel(getValues()),
    footerEndButton: {
      children: submitText,
      isDisabled: false,
      isLoading: false,
      type: "submit",
      form: formId
    },
    footerStartButton: {
      children: cancelText,
      isDisabled: false,
      isLoading: false,
      type: "button",
      form: formId
    },
    trigger,
    title,
    customElement
  };
  return /* @__PURE__ */ jsx(ModalProvider, { submitText, children: /* @__PURE__ */ jsx(Box, { flexGrow: { "breakpoint.base": 1, "breakpoint.sm": 0 }, children: isUpdated ? /* @__PURE__ */ jsx(FiltersModal, { ...filterModalProps }) : /* @__PURE__ */ jsx(Skeleton, { width: "100%", height: 48, testId: SearchEditSkeletontestId }) }) });
};
var SearchEditWithMFEContext = ({
  initialModel,
  onSubmit,
  formId = RefinerFormDefaultId,
  ...rest
}) => {
  const templates = useTemplates();
  return /* @__PURE__ */ jsx(
    WithFormProvider,
    {
      initialModel: mapSearchModelToFormModel(initialModel, templates),
      formId,
      onSubmit: async (data) => {
        await onSubmit(mapFormModelToSearchModel(data, templates));
      },
      children: /* @__PURE__ */ jsx(SearchEditTemplate, { ...rest, formId })
    }
  );
};
var SearchEdit = ({ stage, brand, locale, ...rest }) => /* @__PURE__ */ jsx(WithMFEContext, { brand, locale, stage, children: /* @__PURE__ */ jsx(SearchEditWithMFEContext, { ...rest }) });

export { SearchEdit };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=edit.js.map